export default __webpack_public_path__ + "static/media/phones.cc37d63a.png";